import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { useParams } from 'next/navigation'
import {
  QUERY_CANCELLATION_POLICIES_KEY,
  fetchCancellationPolicies,
} from './fetchCancellationPolicies'
import useAuthentication from '../useAuthentication'
import type { CancellationPoliciesResponse } from 'tokyu-hooks/lib/response/hotel'

function useQueryCancellationPolicies(
  hotelCode?: string,
  roomPlanCodes?: string[],
): UseQueryResult<CancellationPoliciesResponse | null> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { withTriplaApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [
      QUERY_CANCELLATION_POLICIES_KEY,
      { hotelCode, locale, roomPlanCodes },
    ],
    queryFn: withTriplaApiRequest(fetchCancellationPolicies),
    enabled: !!hotelCode,
  })
}

export default useQueryCancellationPolicies
